<template>
  <div style="margin-bottom: 120px;">
    <el-alert v-if="selectedRoomsList.length >= 31" title="單筆訂單 31 晚 為上限" type="error" center show-icon style="position: fixed; bottom:85px; z-index: 3; width: 90%; " />
    <div v-for="(type, typeIndex) in roomTypeList" :key="`type-${typeIndex}`">
      <div style="margin-bottom: 32px;border-top:solid 12px #F9FAFB;" class="roomType">
        <el-row style="display: flex;">
          <el-col :span="7" style="background-color: #f2f2f2;padding: 8px 0px;">
            <el-row>
              <div style="display: flex; align-items: stretch;line-height: 1.8;margin-bottom: 4px; cursor: pointer" @click="type.isViewMore = !type.isViewMore">
                <el-col :span="8">
                  <div>
                    <img v-if="type.image" :src="type.image" :alt="`${type.title}照片`" style="width: 91px;height: 70px; object-fit: cover; border-radius: 8px;" />
                    <img v-else src="@assets/images/default_room.jpg" alt="預設房型圖片" style="width: 91px;height: 70px; object-fit: cover; border-radius: 8px;" />
                  </div>
                  <el-popover placement="right-start" trigger="click" width="160" popper-class="settings-menu-popper">
                    <div style="display: flex; flex-direction: column; gap: 10px; padding: 5px 0;">
                      <el-popover placement="right-start" trigger="click" width="450" @click.stop>
                        <el-button slot="reference" round size="small" @click.stop style="width: 100%; margin-left: 0;">
                          查看可入住種類
                        </el-button>

                        <div style="max-height: 250px; overflow-y: auto; width:auto;">
                          <div style="font-weight: bold; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 4px;position:fixed;background-color: #ffffff;width:420px">
                            所有可入住種類 (共 {{ type.categories.length }} 項)
                          </div>
                          <div style="margin-top:28px">
                            <div v-for="(item, index) in type.categories" :key="index" style="padding: 8px 0; font-size: 14px; border-bottom: 1px dashed #f0f0f0; ">
                              {{ item.title }}
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </div>

                    <el-button slot="reference" type="text" icon="el-icon-setting" @click.stop style="font-size: 28px;  padding-right: 40px;"> </el-button>
                  </el-popover>
                </el-col>
                <el-col :span="14" style=" text-align: left;margin-left: 4px; color:#6C6B6B">
                  <div style="font-weight: bold; color:#121931; font-size:16px;">
                    {{ type.title }}
                    <span style="font-size: 12px; color: #6C6B6B"> | {{ type.rooms.length }}間 </span>
                  </div>
                  <div> 可入住數：1~{{ type.accommodates }}</div>
                  <div>
                    <div v-for="(item, index) in type.categories.slice(0, 3)" :key="`Category-${index}`">
                      {{ item.title }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="1" style="display: flex; align-items: center;">
                  <template>
                    <font-awesome-icon
                      :icon="['far', 'chevron-down']"
                      :style="{
                        color: '#ea6a2a',
                        fontSize: '16px',
                        transition: 'transform 0.6s ease',
                        transform: type.isViewMore ? 'rotate(180deg)' : 'rotate(0deg)',
                      }"
                    />
                  </template>
                </el-col>
              </div>
            </el-row>
            <!-- <el-row>
              <el-col :span="12">
                <el-button style="width:90%;border-radius: 8px;">房型設定</el-button>
              </el-col>
              <el-col :span="12">
                <el-button style="width:90%;border-radius: 8px;">房況管理</el-button>
              </el-col>
            </el-row> -->
          </el-col>
          <el-col :span="17" style="padding: 0px; display: flex; flex-direction: column;">
            <el-row style="flex: 1; display: flex; flex-wrap: wrap;">
              <el-col
                v-for="(defaultPrice, defaultPriceIndex) in type.defaultPrices"
                :key="`defaultPrice-${defaultPriceIndex}`"
                :span="3"
                style="
                                border:solid 1px #0000000F;
                                margin:0px 6px;
                                background-color: #ffffff;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            "
              >
                NT${{ formatNumber(defaultPrice) }}
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <!-- 跑每個房型的房間數迴圈 -->
        <el-row v-show="type.isViewMore" v-for="(room, roomIndex) in type.rooms" :key="`room-${roomIndex}`" class="room" :class="type.isViewMore ? 'fade-in' : 'fade-out'">
          <el-col :span="7" style="background-color: #ffffff;">
            <div style="display: flex; justify-content: left;align-items: center; padding:0 8px">
              <div style="font-weight: 400; color:#000000;padding-left:12px">{{ room.roomTitle }}</div>
              <!-- <el-button type="text" color="#626aef" @click="checkIn"> <i class="fal fa-edit fa-md"></i>房況管理 </el-button> -->
            </div>
          </el-col>
          <el-col :span="17" style="padding: 0px;">
            <el-row>
              <el-col
                v-for="(dateRoom, dateRoomIndex) in room.availabilityByDate"
                :key="`dateRoom-${dateRoomIndex}`"
                :span="3"
                :class="{
                  'selected-cell': isSelected(room.roomId, dateRoom.date),
                  'disabled-cell': isDisabledCell(room.roomId, dateRoom.date, dateRoom),
                }"
                :style="{
                  backgroundColor: StatusMetaMap[dateRoom.status].color,
                  color: StatusMetaMap[dateRoom.status].textColor,
                  cursor:
                    [RoomStatusEnum.CLOSE, RoomStatusEnum.BOOKING, RoomStatusEnum.RESERVE].includes(dateRoom.status) || isDisabledCell(room.roomId, dateRoom.date, dateRoom)
                      ? 'not-allowed'
                      : 'pointer',
                }"
                style="margin:0px 6px;border: solid 1px #E5E7EB;"
              >
                <span
                  v-if="[RoomStatusEnum.CLOSE, RoomStatusEnum.BOOKING, RoomStatusEnum.RESERVE].includes(dateRoom.status) || isDisabledCell(room.roomId, dateRoom.date, dateRoom)"
                  class="ellipsis-text"
                >
                  {{ StatusMetaMap[dateRoom.status].label }}
                </span>
                <span v-else class="ellipsis-text" @click="handleDateRoomClick(type, room, dateRoom)"> NT${{ formatNumber(dateRoom.priceStartAt) }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 底部顯示操作區 -->
    <div
      style="
            position: fixed;
            bottom: 0;
            right: 0;
            left: 0;
            width: 100%;
            height: 80px;
            background-color: #ffffff;
            border-top: 1px solid #E5E7EB;
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px 0 90px;
            z-index: 2;"
    >
      <div style="display: flex; align-items: center; justify-content: space-between;width:100%;">
        <div style="display: flex; flex-direction: column; align-content: center;line-height: 1.8; width: 68%;">
          <div style="display: flex; align-items: center;justify-content: space-between; ">
            <span style="font-size: large;font-weight:500; color: #000000;">請選擇欲入住的日期及房型</span>
            <span style="color: #000000;"> 一天僅可選一間房間含不同房型，<span style="color: #ea6a2a;">再次點擊房間</span>將取消已選擇房間</span>
          </div>
          <div style="color: #6C6B6B;display: flex; align-items: center;justify-content: left;">
            <div>
              {{ selectedStayRange || '請選擇入住日期及房型' }}｜當前房型可入住至多
              <span style="color: #ea6a2a; font-size: large; font-weight: 500;">{{ currentMaxAccommodates || 0 }}</span>
              隻
            </div>
          </div>
        </div>
        <el-button
          :disabled="selectedRoomsList.length === 0"
          @click="onClickNextStep"
          :style="{
            opacity: selectedRoomsList.length === 0 ? 0.5 : 1,
          }"
          style="
                    background-color:#ea6a2a;
                    color:#ffffff;
                    border-radius: 8px;
                    width:300px;
                    height:50px;
                    "
          >下一步
        </el-button>
      </div>
    </div>
    <!-- 預約住宿訂單彈窗 -->
    <hotelBookingOrder v-model="isOpenOrderForm" :selectedRoomsList="selectedRoomsList" @clear-chosen-rooms="closeBookingOrder" @reload-order-list="reloadOrderList" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { StatusMetaMap } from '../enums/statusMap'
import { RoomStatusEnum } from '../enums/roomStatusEnum'
import { formatHotelStayRange } from '@utils/format-hotel-stay'

import hotelBookingOrder from './order/hotelBookingOrder.vue'

export default {
  name: 'hotelBookingMode',
  components: {
    FontAwesomeIcon,
    hotelBookingOrder,
  },
  props: {
    roomTypeList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      StatusMetaMap,
      RoomStatusEnum,
      selectedRoomsList: [],
      isOpenOrderForm: false,
    }
  },
  computed: {
    selectedStayRange() {
      return formatHotelStayRange({
        bookings: this.selectedRoomsList,
        showCheckoutDate: this.showCheckoutDate,
      })
    },
    currentMaxAccommodates() {
      if (!this.selectedRoomsList || this.selectedRoomsList.length === 0) return 0
      return Math.min(...this.selectedRoomsList.map((item) => item.type.accommodates))
    },
    selectedDatesSet() {
      return new Set(this.selectedRoomsList.map((item) => item.date))
    },
    selectedRoomDateList() {
      return this.selectedRoomsList.map((room) => room.date)
    },
    ...mapGetters('hotel/order', ['adminBackfillMode']),
    ...mapGetters('hotel/setting', ['showCheckoutDate']),
  },
  methods: {
    checkIn() {
      alert('您的毛孩已成功入住！')
    },
    formatNumber(num) {
      return num?.toLocaleString() // 會自動加上千位逗號
    },
    emitRoomSelection() {
      this.$emit('rooms-selected', this.selectedRoomsList)
    },
    emptySelectedRooms() {
      this.selectedRoomsList = []
      this.emitRoomSelection() // Emit empty selection to parent
    },
    handleDateRoomClick(type, room, dateRoom) {
      const roomId = room.roomId
      const date = dateRoom.date

      // 1. 檢查這格是否已經選了 (用 roomId + date)
      const existingIndex = this.selectedRoomsList.findIndex((item) => item.roomId === roomId && item.date === date)

      if (existingIndex !== -1) {
        // 已選過 -> 取消選取
        this.selectedRoomsList.splice(existingIndex, 1)
      } else {
        // 2. 強制「一天一間」：如果這天已經選了別間，先刪掉那一筆
        const sameDateIndex = this.selectedRoomsList.findIndex((item) => item.date === date)
        if (sameDateIndex !== -1) {
          this.selectedRoomsList.splice(sameDateIndex, 1)
        }

        // 3. 加入新選取的資訊
        this.selectedRoomsList.push({
          roomId,
          date,
          room,
          type,
          dateRoom,
        })
      }
      const max = Math.min(...this.selectedRoomsList.map((item) => item.type.accommodates))
      this.emitRoomSelection()

      this.$store.commit('hotel/order/SET_MAXACCOMMODATES', max)
      this.$store.commit('hotel/order/SET_BOOKING', [...this.selectedRoomsList])
    },
    isSelected(roomId, date) {
      return this.selectedRoomsList.some((item) => item.roomId === roomId && item.date === date)
    },

    isDisabledCell(roomId, date, dateRoom) {
      if (this.isSelected(roomId, date)) return false

      // 狀態禁用 (BOOKING/CLOSE等)
      if ([RoomStatusEnum.CLOSE, RoomStatusEnum.BOOKING, RoomStatusEnum.RESERVE].includes(dateRoom.status)) return true

      // 業務禁用：同一天已選了其他房間
      const hasOtherRoomThisDate = this.selectedRoomsList.some((item) => item.date === date && item.roomId !== roomId)
      if (hasOtherRoomThisDate) return true

      // 上限禁用：單筆訂單 31晚一個月
      return this.selectedRoomsList.length >= 31
    },
    closeBookingOrder() {
      this.$emit('leave-booking-mode')
    },
    onClickNextStep() {
      if (this.selectedRoomsList.length > 31) {
        this.$message({
          message: `抱歉，單筆訂單上限為 31 晚，目前已選 ${this.selectedRoomsList.length} 晚。`,
          type: 'error',
          center: true,
        })
        return
      }

      if (!this.checkDateContinuity()) {
        this.$message({
          message: '您選擇的日期不連續，請補齊中間的日期或重新選擇',
          type: 'error',
          center: true,
        })
        return
      }
      this.isOpenOrderForm = true
    },
    checkDateContinuity() {
      if (this.adminBackfillMode) {
        return true
      }
      if (this.selectedRoomsList.length <= 1) return true

      const sortedTimestamps = this.selectedRoomsList
        .map((item) => {
          return new Date(item.date.replace(/-/g, '/')).getTime()
        })
        .sort((a, b) => a - b)

      const ONE_DAY_MS = 24 * 60 * 60 * 1000

      for (let i = 0; i < sortedTimestamps.length - 1; i++) {
        const diff = sortedTimestamps[i + 1] - sortedTimestamps[i]
        if (Math.round(diff) !== ONE_DAY_MS) {
          return false
        }
      }
      return true
    },
    reloadOrderList() {
      this.$emit('reload-order-list')
    },
  },
}
</script>
<style scoped lang="scss">
.el-button--text {
  font-weight: 400;
  color: #ea6a2a;
}

.el-col {
  text-align: center;

  .roomType .room & {
    line-height: 65px;
  }
  .statusCalendar & {
    height: 57px;
    line-height: 20px;
  }
}

.fade-in {
  animation: fadeIn 0.8s ease forwards;
}
.fade-out {
  animation: fadeOut 0.4s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-5px);
  }
}

.ellipsis-text {
  display: inline-block;
  max-width: 85px; /* 可依需求調整寬度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.selected-cell {
  box-shadow: 0 0 0 1px #ea6a2a inset;
  border-color: #ea6a2a !important;
  background-color: #fdf0e9 !important;
  border-radius: 8px;
}

.disabled-cell {
  opacity: 0.7;
}
</style>
